/* src/app/features/naturezas-juridicas-aceitas/listagem/repasse-listagem/repasse-listagem.component.scss */
.table-responsive {
  margin-top: 40px;
}
select#nome option .right-aligned {
  text-align: right;
  display: block;
}
/*# sourceMappingURL=repasse-listagem.component.css.map */
